module.exports = __webpack_public_path__ + "static/hkind-export-016df2cc1e51d84f6e79b83fb94b633c.mp4";